import { Text } from '@mantine/core'
import { IconRefresh } from '@tabler/icons-react'
import clsx from 'clsx'
import classes from './UpdatedBar.module.css'
import { formatDateString } from '../../helpers'
import { useMediaQuery } from '@mantine/hooks'
import { useCompetition } from './api'
import { useCompetitionId } from '../../hooks'

export default function UpdatedBar() {
  const isDesktop = useMediaQuery('(min-width: 800px)')
  const competitionId = useCompetitionId()
  const { data: competition } = useCompetition(competitionId)
  const last_updated = competition?.last_updated

  if (!last_updated) {
    return null
  }

  return (
    <div
      className={clsx(classes.update_container, {
        [classes.update_container_mobile]: !isDesktop,
      })}
    >
      <div className={classes.update_wrapper}>
        <IconRefresh className={classes.refresh_icon} />
        <Text component="p">Updated</Text>
      </div>
      <Text component="p" className={classes.last_update}>
        {formatDateString(last_updated)}
      </Text>
    </div>
  )
}
